import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>
  createStyles({
    container: {
      zIndex: theme.zIndex.drawer + 1,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    img: {
      display: 'flex',
      width: 'auto',
      maxHeight: '90vh',
    },
    imageName: {
      marginTop: '1rem',
    },
  }),
);

export default useStyles;
